angular.module('MyApp')
  .controller('MdpCtrl', function ($rootScope, $scope, $location, $auth, toastr, services) {
    $scope.url_ = $rootScope.url_;

    /* test
    $scope.displayName="vero"
    $scope.email="vero_01@laposte.net" 
    $scope.password="vero"
    $scope.confirmPassword="vero"
    */

    //$scope.user = {'token': sessionStorage.getItem("token"),'email': sessionStorage.getItem("mail"), 'id': sessionStorage.getItem("id"), 'nom': sessionStorage.getItem("nom") };

    $scope.displayName = $rootScope.user.nom;
    $scope.email = $rootScope.user.mail;
    $scope.OldPassword = "";
    $scope.NewPassword = "";
    $scope.confirmPassword = "";

    $scope.mdp = function () {

      services.UpdateMDP({
        email: $rootScope.user.mail,
        OldPassword: $scope.OldPassword,
        NewPassword: $scope.NewPassword,
        confirmPassword: $scope.confirmPassword

      }).then(function () {
        toastr.success('___le mot de passe a été changé___');
        setTimeout(function () {
          $scope.ssDomaine = "";

          $scope.ressource = { "niveau": "", "ssDomaine": "", "description": "", "autreSsDomaine": "", "ssDomainePropose": "", "domaine": "", "type": "", "duree": "", "secret": true, "mail": "" }
        }, 350);


        $location.path('/1qcm');

      })
        .catch(function (response) {
          toastr.error('___opération impossible. Voir mail ou ancien mot de passe___');
        });
    };


    $scope.forget = function () {
      alert("mail1 : " + $scope.email);
      services.mail($scope.email);//.then(function(){});
    };


  });